import { useState } from "react";
import img1 from "../../../Assets/About/history-1.jpeg";
import img2 from "../../../Assets/About/history-2.jpeg";
import img3 from "../../../Assets/About/history-3.jpg";
import img4 from "../../../Assets/About/history-4.jpg";
import img5 from "../../../Assets/About/history-5.jpeg";

const timelineData = [
  {
    year: "2005",
    title: "Strength to strength within the industry",
    description:
      "Founded in 2005 in Odisha, we began operations with iron ore extraction, building a strong foundation in mining practices. With a dedicated team and efficient site management, we quickly established ourselves as a reliable name in the regional mining sector.",
    image: img1,
  },
  {
    year: "2010",
    title: "Expanding our reach in 3 states",
    description:
      "By 2010, we expanded into Chhattisgarh and Jharkhand, diversifying into bauxite and limestone mining. This strategic move allowed us to access richer mineral reserves, scale operations, and strengthen our supply chain across multiple states.",
    image: img2,
  },
  {
    year: "2015",
    title: "A decade of innovation and growth",
    description:
      "Celebrating 10 years, we modernized our mining operations with advanced drilling and crushing technologies. Across Odisha, Chhattisgarh, and Jharkhand, we improved iron ore, bauxite, and limestone extraction efficiency while prioritizing safety and environmental standards.",
    image: img3,
  },
  {
    year: "2020",
    title: "Resilience across state operations",
    description:
      "Despite operational challenges, our multi-state presence ensured continuity in iron ore, bauxite, and limestone production. We adopted digital monitoring systems and remote site management to maintain productivity and streamline coordination across all locations.",
    image: img4,
  },
  {
    year: "2023",
    title: "Expanding across state mining sectors",
    description:
      "We continue expanding our footprint across key mining states, enhancing production capacity in iron ore, bauxite, and limestone. With a focus on sustainable mining, modern equipment, and efficient logistics, we are building a future-ready mining enterprise.",
    image: img5,
  },
];
export default function MiningHistory() {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = timelineData[activeIndex];

  return (
    <div className="bg-white w-full min-h-screen px-4 sm:px-8 lg:px-16 py-14 font-sans">
      {/* ── Header ── */}
      <div className="max-w-7xl mx-auto mb-10">
        <p
          className="text-xs font-bold tracking-[0.2em] uppercase text-gray-500 mb-3 border-b-2 border-red-600 inline-block"
          style={{ paddingBottom: "1px" }}
        >
          OUR HISTORY
        </p>
        <h1
          className="text-5xl font-black text-gray-900 leading-[1.1] mt-2"
          style={{
            fontFamily: "'Arial Black', Arial, sans-serif",
            letterSpacing: "-0.02em",
          }}
        >
          We build everything
          <br />
          that needed you
        </h1>
      </div>

      {/* ── Timeline ── */}
      <div className="relative mb-14 max-w-7xl mx-auto">
        {/* Line */}
        <div className="absolute top-[7px] left-0 right-0 h-px bg-gray-900" />

        <div className="relative flex justify-between items-start">
          {timelineData.map((item, i) => {
            const isActive = i === activeIndex;
            return (
              <button
                key={item.year}
                onClick={() => setActiveIndex(i)}
                className="flex flex-col items-center group focus:outline-none"
                style={{ minWidth: "60px" }}
              >
                {/* Dot */}
                <div
                  className={`w-3.5 h-3.5 rounded-full border-2 transition-all duration-300 z-10 ${
                    isActive
                      ? "bg-red-500 border-red-500 scale-125"
                      : "bg-white border-red-400 group-hover:bg-red-300 group-hover:scale-110"
                  }`}
                />
                {/* Year label */}
                <span
                  className={`mt-3 text-lg font-black transition-colors duration-300 ${
                    isActive
                      ? "text-red-500"
                      : "text-gray-900 group-hover:text-red-400"
                  }`}
                  style={{ fontFamily: "'Arial Black', Arial, sans-serif" }}
                >
                  {item.year}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Content Panel ── */}
      <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-12 relative min-h-[340px] max-w-7xl mx-auto">
        {/* Left: Ghost year + title + description */}
        <div className="flex-1 relative">
          {/* Ghost year watermark */}
          <p
            className="absolute -top-4 left-0 text-[120px] font-black leading-none select-none pointer-events-none"
            style={{
              fontFamily: "'Arial Black', Arial, sans-serif",
              color: "rgba(239,68,68,0.08)",
              letterSpacing: "-0.04em",
              zIndex: 0,
            }}
          >
            {active.year}
          </p>

          <div className="relative z-10 pt-16">
            <h2
              className="text-3xl font-black text-gray-900 leading-tight mb-5"
              style={{ fontFamily: "'Arial Black', Arial, sans-serif" }}
            >
              {active.title}
            </h2>
            <p className="text-gray-500 text-base leading-relaxed max-w-md">
              {active.description}
            </p>
          </div>
        </div>

        {/* Right: Image */}
        <div className="w-full lg:w-[55%] flex-shrink-0 rounded-2xl overflow-hidden shadow-xl aspect-video">
          <img
            key={active.year}
            src={active.image}
            alt={active.title}
            className="w-full h-full object-cover transition-opacity duration-500"
            style={{ minHeight: "280px" }}
            onError={(e) => {
              e.target.src =
                "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=900&q=80";
            }}
          />
        </div>
      </div>
    </div>
  );
}
